module.exports = __webpack_public_path__ + "media/images/profile/back-5fd1e19335399d0c112190d343c400d5.svg";